import React from "react";
import getTime from "../../helpers/getTime";
import moment from "moment";
import useSchedule from "../../hooks/useSchedule";

export interface NextSessionsWidgetProps {
  limit?: number;
}

const NextSessionsWidget = ({ limit = 2 }: NextSessionsWidgetProps) => {
  const schedule = useSchedule();

  return (
    <div className="space-y-4">
      <div className="text-xs text-gray-400">Next Sessions</div>
      {schedule && schedule.length ? (
        schedule
          .filter(
            (item) =>
              getTime(new Date(item.timeStart).toISOString()) >= getTime()
          )
          .slice(0, limit)
          .map((item, key) => {
            const { title, timeStart, timeEnd } = item;

            return (
              <div className="space-y-2" key={key}>
                <div className="text-lg font-medium text-cream">{title}</div>
                <div className="text-xs text-gray-400">
                  {moment(timeStart).format("H:mm")} -{" "}
                  {moment(timeEnd).format("H:mm")}
                </div>
              </div>
            );
          })
      ) : (
        <div className="w-full p-4 my-2 text-sm text-center text-gray-400 bg-gray-100 rounded">
          No sessions available.
        </div>
      )}
    </div>
  );
};

export default NextSessionsWidget;
